import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/login/Index'),
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      meta: {
        requiresAuth: true,
      },
      children: [
         {
          name: 'Agencies',
          path: '',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/Agencies'),
        },
        {
          name: 'Caregivers',
          path: 'caregivers',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/Caregivers'),
        },
        {
          name: 'Employees',
          path: 'employees',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/Employees'),
        },
        {
          name: 'Clients',
          path: 'clients',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/Clients'),
        },
        {
          name: 'Users',
          path: 'users',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/Users'),
        },
        {
          name: 'Shifts',
          path: 'shifts',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/Shifts'),
        },
        {
          name: 'Admin Users',
          path: 'iadmins',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/InternalAdmins'),
        },
        {
          name: 'Admin Groups',
          path: 'admingroups',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/AdminGroups'),
        },
        {
          name: 'Reports',
          path: 'reports',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/Reports'),
        },
        {
          name: 'Settings',
          path: 'settings',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/Settings'),
        },
        {
          name: 'Mobile Health',
          path: 'mobilehealth',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/MobileHealth'),
        },
        {
          name: 'ADP Subscriptions',
          path: 'adpsubscriptions',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/AdpSubscriptions'),
        },
        {
          name: 'Bull Dashboard',
          path: 'bull-dashboard',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/BullDashboard'),
        },
        {
          name: 'Event Log',
          path: 'event-log',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/EventLog'),
        },
        {
          name: 'Community Members',
          path: 'community-members',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/CommunityMembers'),
        },
        {
          name: 'LMS',
          path: 'lms',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/Lms'),
        },
        {
          name: 'API Keys',
          path: 'api-keys',
          meta: {
            requiresAuth: true,
          },
          component: () => import('@/views/dashboard/ApiKeys'),
        },
      ],
    },
    // catch all redirect
    {
      path: '*',
      name: 'MyRedirect',
      redirect: { name: 'Agencies' },
    },
  ],
})

const isAuthenticated = () => store.getters['app/IS_AUTHENTICATED']

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) { next({ name: 'Login' }) } else { next() }
})

export default router
